import { TrashSimple } from "@phosphor-icons/react"
import { useDeMedicationDetailByIdQuery } from "@/modules/patients/detail/medication/de/services/useDeMedicationDetailByIdQuery"

interface DeleteMedicationButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  id: string
}

const DeleteMedicationButton = ({ id, ...props }: DeleteMedicationButtonProps) => {
  const medication = useDeMedicationDetailByIdQuery({ id, fetchPolicy: "network-only" })

  return (
    medication?.result?.canDelete && (
      <button data-testid="delete-button" {...props}>
        <TrashSimple className="text-on-surface-subdued" />
      </button>
    )
  )
}

export { DeleteMedicationButton }
